import React from 'react';
import PropTypes from 'prop-types';
import ErrorLabel from '../ErrorLabel';
import { transformLabels } from '../../../../utils/misc';
import styled from 'styled-components';
import { Colors } from '~/src/scss/common/style';

interface TextAreaComponentProps {
  name: string;
  value: string | number;
  onBlur: any;
  onChange: any;
  cols?: number;
  rows?: number;
  errorMessage?: string | null;
  colorLabel?: string;
}

export default function TextAreaComponent({
  name,
  value,
  onBlur,
  onChange,
  cols = 6,
  rows = 2,
  errorMessage = null,
  colorLabel,
}: TextAreaComponentProps): JSX.Element {
  return (
    <div className={`form-group col-sm-${cols}`}>
      <LabelStyle colorLabel={colorLabel} className="ak-form-labels" htmlFor={name}>
        {transformLabels(name)}
      </LabelStyle>
      <TextArea
        name={name}
        onBlur={onBlur}
        onChange={onChange}
        value={value}
        rows={rows}
        className="form-control"
      />
      {errorMessage && <ErrorLabel error={errorMessage} />}
    </div>
  );
}

const TextArea = styled.textarea`
  padding-left: 10px !important;
  border-color: #eeeeee !important;
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  ::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  border: 1px solid #eeeeee;
  border-radius: 10px;
  &:active {
    box-shadow: none !important;
    border: 1px solid #eeeeee;
    border-color: #eeeeee !important;
  }
  &:hover {
    box-shadow: none !important;
    border: 1px solid #eeeeee;
    border-color: #eeeeee !important;
  }
  &:focus {
    box-shadow: none !important;
    border: 1px solid #eeeeee;
    border-color: #eeeeee !important;
  }
  &:target {
    box-shadow: none !important;
    border: 1px solid #eeeeee;
    border-color: #eeeeee !important;
  }
  &:visited {
    box-shadow: none !important;
    border: 1px solid #eeeeee;
    border-color: #eeeeee !important;
  }
`;

const LabelStyle = styled.label`
  font-weight: 700;
  font-size: 15px;
  line-height: 16px;
  color: ${(props) => (props.colorLabel ? props.colorLabel : Colors.darkBrown)};
  text-align: left;
  width: 100%;
  margin-left: 8px;
  margin-bottom: 11px;
  margin-right: 6px;
`;
